import React, { useCallback } from 'react';
import { BlockNavigationModalBase } from './BlockNaviagtionModalBase';
import { useLocalizationContext } from '../../../localization/LocalizationContext';
import { unblockNavigation } from '../../../store/actions/blockNavigation';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { RootState, UIState } from '../../../store/types';

export const BlockNavigationModal = () => {
    const localization = useLocalizationContext();
    const dispatch = useAppDispatch();
    const stateProps = useAppSelector((store: RootState) => store.ui.blockNavigation) as UIState['blockNavigation'];
    const {
        isOpen,
        canLeave,
        title,
        body,
        cancelButtonText,
        confirmButtonText,
        isHighAlertButton
    } = stateProps;
    const onConfirm = useCallback(() => {
        dispatch(unblockNavigation());
        if (canLeave) {
            canLeave(true);
        }
    }, [canLeave, dispatch]);

    const onCancel = useCallback(() => {
        if (canLeave) {
            canLeave(false);
        }
    }, [canLeave]);

    return React.createElement(BlockNavigationModalBase, {
        localization,
        isOpen,
        onConfirm,
        onCancel,
        title,
        body,
        cancelButtonText,
        confirmButtonText,
        isHighAlertButton
    });
};
